import PropTypes from 'prop-types';
import _ from 'lodash';

const errorStyles = {
  position: 'absolute',
  color: '#f44336',
  fontSize: '12px',
  fontWeight: '600',
  letterSpacing: '0.1px',
  bottom: '0px',
};

function RadioButton({
  value = null,
  onChange,
  options,
  label = undefined,
  required = false,
  error = undefined,
}) {
  const className = required ? 'onboarding-label-required' : 'onboarding-label';

  return (
    <div className="radio-button-group">
      {label && <p className={className}>{label}</p>}
      {_.map(options, (option, i) => (
        <label key={i}>
          <input
            type="radio"
            value={option.value}
            checked={value?.toString() === option.value.toString()}
            onChange={() => onChange(option.value)} // pass back just the value
          />
          <span />
          <p>{option.label}</p>
        </label>
      ))}
      {error && <p style={errorStyles}>{error}</p>}
    </div>
  );
}

RadioButton.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  required: PropTypes.bool,
  error: PropTypes.string,
};

export default RadioButton;
